export default __webpack_public_path__ + "static/media/mediaPicture.1607802c.svg";